class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);

    if (this.removeAnnounceGiftWarning) {
      this.removeAnnounceGiftWarning();
      this.removeAnnounceGiftWarning = null;
    }
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key || parsedState.items?.[parsedState.items.length - 1]?.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    this.toggleGiftMessage();

    this.removeAnnounceGiftWarning = this.announceGiftWarning();

    if (this.header) this.header.reveal();
    this.open();
    this.removeGuestIneligibleLines();
  }

  async removeGuestIneligibleLines() {
    const button = document.querySelector('#cart-notification-button [data-guest-ineligible-line-keys]');
    let keys = [];
    try {
      keys = JSON.parse(button?.dataset.guestIneligibleLineKeys || '[]');
    } catch (e) {
      return;
    }
    if (!keys.length) return;
    const updates = Object.fromEntries(keys.map((key) => [key, 0]));
    try {
      const response = await fetch(`${routes.cart_update_url}.js`, {
        ...fetchConfig(),
        body: JSON.stringify({ updates }),
      });
      if (!response.ok) throw new Error(`cart update ${response.status}`);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Guest ineligible cleanup: error during add to cart', err);
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  announceGiftWarning() {
    const giftWarningElement = this.notification.querySelector('#cart-notification-gift-message');

    if (!this.notification || !giftWarningElement) {
      return () => {};
    }

    const warningNode = document.createElement('div');
    warningNode.classList.add('visually-hidden');
    warningNode.textContent = giftWarningElement.textContent;
    this.notification.prepend(warningNode);
    return () => {
      warningNode.remove();
    };
  }

  toggleGiftMessage() {
    const giftMessage = this.notification.querySelector('[data-cart-notification-gift-message]');
    if (!giftMessage) return;

    const productContainer = document.getElementById('cart-notification-product');
    const giftContext = productContainer?.querySelector('[data-cart-notification-gift-context]');

    if (giftContext) {
      giftMessage.dataset.initialHasGiftItems = giftContext.dataset.hasGiftItems;
    }

    const hasGiftItems = giftMessage.dataset.initialHasGiftItems === 'true';
    const lastItemIsSubscription = giftContext?.dataset.lastItemIsSubscription === 'true';
    const shouldShowGiftMessage = Boolean(giftContext) && hasGiftItems && !lastItemIsSubscription;

    giftMessage.hidden = !shouldShowGiftMessage;
  }
}

customElements.define('cart-notification', CartNotification);
